import { Dataset, MapType } from "./dataset";
import { environment } from "../../environments/environment";

export class AtlasMobileAreaDataset extends Dataset {
  protected mapBaseUrl: string =
    environment.geoServer.baseUrl + environment.geoServer.dp_mobile_byzone_overview;

  protected mapPositionInfoUrl?: string = null;

  public legend = null;

  protected statisticsBaseUrl: string = null;

  protected attribution: string = undefined;

  getMapType(): MapType {
    return MapType.RASTER;
  }
}
